import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RefreshTokenRequest, RefreshTokenResponse } from '../models/token-req-res';
import { DataAccess } from './data-access';
import { urls } from '../models/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http: HttpClient = inject(HttpClient);
  constructor() {}

  async refreshToken(refreshTokenRequest: RefreshTokenRequest): Promise<RefreshTokenResponse> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json; charset=utf-8');
    const methodName = 'refresh-token';
    const timeOutVal = 15000;
    const DataAccessObj = new DataAccess(this.http, urls.apiUrl);
    return DataAccessObj.postData(methodName, refreshTokenRequest, headers, timeOutVal)
    .then(res => res as RefreshTokenResponse);
  }
}
